import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { ManageSeatingInitStepDeclaration } from "./Steps/ManageSeatingInitStep";

export const manageSeatingStartupFlow = new FlowDefinition("ManageSeatingFlow");

manageSeatingStartupFlow.addStep(ManageSeatingInitStepDeclaration);
// CheckoutFlow is intentionally NOT a sub-step here. It is started top-
// level by ClientProvider's pathname handler when the route changes to
// /checkout (after ManageSeatingInit_Step emits ROUTE_CHANGE). Embedding
// CheckoutFlow here previously caused two PaymentInit_Step instances to
// be alive at once (this one + the top-level CheckoutFlow), which
// compounded across the two event hops in the Pay-click chain into 4
// duplicate POSTs to /api/payment/session. With the backend-handled
// refund architecture, each duplicate POST also triggers a redundant
// refund attempt, which is actively harmful — hence this dedup is
// mandatory, not just a perf nicety.
//
// ManageSeatingTransition is also gone — it only seeded checkout-related
// contexts before transitioning into the embedded CheckoutFlow. The top-
// level CheckoutFlow's CheckoutTransition seeds those contexts itself.

manageSeatingStartupFlow.setStartStep("ManageSeatingInit_Step");

export const manageSeatingStartupStepDefinition = new StepDefinition({
    stepName: "ManageSeatingFlow",
    stepFlow: manageSeatingStartupFlow,
    contextIsolation: false
})
